import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const TrustFeedback = lazyWithPreload(() => import('./TrustFeedback'))
